import React, { createContext } from 'react';

import { useFirestoreFunction } from 'src/hooks/useFirestoreFunction';

import { useFiltersContext } from 'src/providers/FiltersProvider';

import { FUNCTION_NAMES } from '../../common/consts';

import type { PromotionsSummaryReportResult, PromotionsSummaryReportPayload } from '../types';

const PromotionsSummaryReportContext = createContext<{
  data?: PromotionsSummaryReportResult;
  loading?: boolean;
  error?: Error | null;
  mutate: () => void;
}>({
  data: undefined,
  loading: false,
  error: null,
  mutate: () => {},
});

export function usePromotionsSummaryReport() {
  return React.useContext(PromotionsSummaryReportContext);
}

type ReportsProviderProps = {
  children: React.ReactNode;
};

export function PromotionsSummaryReportProvider({ children }: ReportsProviderProps) {
  const { filters } = useFiltersContext();

  const { data, error, isLoading, mutate, isValidating } = useFirestoreFunction<
    PromotionsSummaryReportPayload,
    PromotionsSummaryReportResult
  >({
    name: FUNCTION_NAMES.PROMOTIONS,
    payload: {
      customerType: filters.customerType,
      locationIds: filters.locationIds,
    },
  });

  return (
    <PromotionsSummaryReportContext.Provider
      value={{ data, error, loading: isLoading || isValidating, mutate }}
    >
      {children}
    </PromotionsSummaryReportContext.Provider>
  );
}
